import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P00061PositionType } from '../../Enum/P00061PositionType';

@Component({
  selector: 'app-p00061-installation-position-pac',
  templateUrl: './p00061-installation-position-pac.component.html',
  styleUrls: ['./p00061-installation-position-pac.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
  ],
})
export class P00061InstallationPositionPacComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private modalController: ModalController = inject(ModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  positionRaccordement: number = 0;

  constructor() {}

  async openPositionModal() {
    const modal = await this.modalController.create({
      component: TwoChoicesModalComponent,
      componentProps: {
        title: 'P00061.modal.positionraccordement.title',
        value: this.positionRaccordement,
        firstChoice: {
          title: 'P00061.modal.positionraccordement.option0',
          image:
            '/assets/ecosystem/images/products/P00061/P00061-position-0.png',
          value: 0,
        },
        secondChoice: {
          title: 'P00061.modal.positionraccordement.option1',
          image:
            '/assets/ecosystem/images/products/P00061/P00061-position-1.png',
          value: 1,
        },
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.positionRaccordement = data.value;
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.positionRaccordement =
      this.poolAdditionalData?.wpPositionRaccordementWPPAC ?? 0;
  }

  onSubmit() {
    this.poolAdditionalData!.wpPositionRaccordementWPPAC =
      this.positionRaccordement!;
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00061PositionType = P00061PositionType;
}
